export default "__VITE_ASSET__CQzxAoF7__"